import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

const BACKEND_URL = 'https://web3-pos-v2.gdbok.workers.dev';

const SUPPORTED_TOKENS = ['USDT', 'USDC'];

// ✅ NEW: Supported Fiat currencies
const SUPPORTED_FIAT = [
  { code: 'ARS', name: 'Argentine Peso (ARS)', symbol: '$' },
  { code: 'USD', name: 'US Dollar (USD)', symbol: '$' },
  { code: 'EUR', name: 'Euro (EUR)', symbol: '€' },
  { code: 'MXN', name: 'Mexican Peso (MXN)', symbol: '$' },
  { code: 'BRL', name: 'Brazilian Real (BRL)', symbol: 'R$' },
  { code: 'COP', name: 'Colombian Peso (COP)', symbol: '$' },
  { code: 'CLP', name: 'Chilean Peso (CLP)', symbol: '$' }
];



export const TokenManagement = ({ merchantWallet, onLogout }) => {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);
  const [selectedToken, setSelectedToken] = useState(null);
  const [qrCodeUrl, setQrCodeUrl] = useState('');

  useEffect(() => {
    loadTokens();
  }, []);

  const loadTokens = async () => {
    try {
      const response = await fetch(
        `${BACKEND_URL}/api/merchant/tokens/list?merchantWallet=${merchantWallet}`
      );
      const result = await response.json();

      if (result.success) {
        setTokens(result.tokens);
      }
    } catch (err) {
      console.error('Load tokens error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleShowQR = async (token) => {
    setSelectedToken(token);
    
    const qrData = JSON.stringify({
      tokenId: token.tokenId,
      humanCode: token.humanCode,
      merchantWallet: merchantWallet,
      type: 'POS_INIT'
    });

    try {
      const url = await QRCode.toDataURL(qrData, {
        width: 300,
        margin: 2,
        color: { dark: '#335383FF', light: '#EEEEEEFF' }
      });
      setQrCodeUrl(url);
      setShowQRModal(true);
    } catch (err) {
      console.error('QR generation error:', err);
    }
  };

  return (
    <div style={{
      maxWidth: '900px',
      margin: '0 auto',
      padding: '20px',
      paddingBottom: '40px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      minHeight: '100vh',
      overflow: 'auto'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
      }}>
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '4px' }}>
            🎫 Payment Tokens
          </h1>
          <p style={{ color: '#6b7280', fontSize: '13px' }}>
            {merchantWallet.substring(0, 6)}...{merchantWallet.substring(38)}
          </p>
        </div>
        
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={() => window.location.href = '#/analytics'}
            style={{
              padding: '10px 16px',
              fontSize: '14px',
              fontWeight: '600',
              background: 'white',
              color: '#6366f1',
              border: '1px solid #6366f1',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            📊 Analytics
          </button>
          
          <button
            onClick={() => setShowCreateModal(true)}
            style={{
              padding: '10px 16px',
              fontSize: '14px',
              fontWeight: '600',
              background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            + New Token
          </button>
          <button
            onClick={onLogout}
            style={{
              padding: '10px 16px',
              fontSize: '14px',
              fontWeight: '500',
              background: 'white',
              color: '#ef4444',
              border: '1px solid #ef4444',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            Logout
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
          Loading tokens...
        </div>
      ) : tokens.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '60px 20px',
          background: '#f9fafb',
          borderRadius: '12px',
          border: '2px dashed #d1d5db'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎫</div>
          <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>
            No tokens yet
          </h3>
          <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '20px' }}>
            Create your first payment token to get started
          </p>
          <button
            onClick={() => setShowCreateModal(true)}
            style={{
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '600',
              background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            Create Token
          </button>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '16px' }}>
          {tokens.map(token => (
            <div
              key={token.tokenId}
              style={{
                background: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                padding: '20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                  <h3 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>
                    {token.name}
                  </h3>
                  <span style={{
                    background: '#dbeafe',
                    color: '#1e40af',
                    padding: '4px 10px',
                    borderRadius: '6px',
                    fontSize: '11px',
                    fontWeight: '600',
                    fontFamily: 'monospace'
                  }}>
                    {token.humanCode}
                  </span>
                  <span style={{
                    background: token.status === 'ACTIVE' ? '#d1fae5' : '#fee2e2',
                    color: token.status === 'ACTIVE' ? '#065f46' : '#991b1b',
                    padding: '4px 10px',
                    borderRadius: '6px',
                    fontSize: '11px',
                    fontWeight: '600'
                  }}>
                    {token.status}
                  </span>
                </div>
                
                {token.description && (
                  <p style={{ color: '#6b7280', fontSize: '13px', margin: '0 0 12px 0' }}>
                    {token.description}
                  </p>
                )}
                
              <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: '#6b7280' }}>
  <div>
    <strong style={{ color: '#374151' }}>Token:</strong> {token.genericToken}
  </div>
  <div>
    <strong style={{ color: '#374151' }}>Currency:</strong> {token.fiatCurrency}
  </div>
  <div>
    <strong style={{ color: '#374151' }}>POS Connected:</strong> {token.connectedPOS}
  </div>
</div>
                
                <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '8px', fontFamily: 'monospace' }}>
                  Created: {new Date(token.createdAt).toLocaleDateString()}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => handleShowQR(token)}
                  style={{
                    padding: '8px 16px',
                    fontSize: '13px',
                    fontWeight: '600',
                    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Show QR
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showCreateModal && (
        <CreateTokenModal
          merchantWallet={merchantWallet}
          onClose={() => setShowCreateModal(false)}
          onSuccess={() => {
            setShowCreateModal(false);
            loadTokens();
          }}
        />
      )}

      {showQRModal && selectedToken && (
        <QRModal
          token={selectedToken}
          qrCodeUrl={qrCodeUrl}
          onClose={() => setShowQRModal(false)}
        />
      )}
    </div>
  );
};

const CreateTokenModal = ({ merchantWallet, onClose, onSuccess }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [genericToken, setGenericToken] = useState('');
  const [fiatCurrency, setFiatCurrency] = useState('');  // ✅ NEW
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

const handleCreate = async (e) => {
  e.preventDefault();
  setError('');

  if (!name.trim()) {
    setError('Token name required');
    return;
  }

  if (!genericToken) {
    setError('Please select a token type');
    return;
  }

  // ✅ NEW: Validate fiat currency
  if (!fiatCurrency) {
    setError('Please select a fiat currency');
    return;
  }

  setLoading(true);


    try {
const response = await fetch(`${BACKEND_URL}/api/merchant/tokens/create`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    merchantWallet: merchantWallet,
    name: name.trim(),
    description: description.trim(),
    genericToken: genericToken,
    fiatCurrency: fiatCurrency  // ✅ NEW
  })
});

      const result = await response.json();

      if (!response.ok) {
        setError(result.error || 'Failed to create token');
        setLoading(false);
        return;
      }

      if (result.success) {
        onSuccess();
      }
    } catch (err) {
      console.error('Create token error:', err);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '500px',
        width: '100%',
        maxHeight: '90vh',
        overflow: 'auto'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
          color: 'white',
          padding: '20px',
          borderRadius: '16px 16px 0 0'
        }}>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
            Create New Token
          </h2>
        </div>

        <form onSubmit={handleCreate} style={{ padding: '20px' }}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{
              display: 'block',
              fontSize: '13px',
              fontWeight: '600',
              marginBottom: '6px',
              color: '#374151'
            }}>
              Token Name *
            </label>
            <input
              type="text"
              placeholder="e.g., Main Store, Store #1"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{
              display: 'block',
              fontSize: '13px',
              fontWeight: '600',
              marginBottom: '6px',
              color: '#374151'
            }}>
              Description
            </label>
            <textarea
              placeholder="Optional description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                resize: 'vertical',
                fontFamily: 'inherit',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{
              display: 'block',
              fontSize: '13px',
              fontWeight: '600',
              marginBottom: '6px',
              color: '#374151'
            }}>
              Token Type *
            </label>
            <select
              value={genericToken}
              onChange={(e) => setGenericToken(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                boxSizing: 'border-box'
              }}
            >
              <option value="">Select token...</option>
              {SUPPORTED_TOKENS.map(token => (
                <option key={token} value={token}>
                  {token}
                </option>
              ))}
            </select>
            <p style={{
              fontSize: '12px',
              color: '#6b7280',
              marginTop: '6px',
              margin: '6px 0 0 0'
            }}>
              Payments can be received in any supported chain (Polygon, BSC, Avalanche, Optimism)
            </p>
          </div>

{/* ✅ NEW: Fiat Currency Selector */}
<div style={{ marginBottom: '16px' }}>
  <label style={{
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    marginBottom: '6px',
    color: '#374151'
  }}>
    Fiat Currency *
  </label>
  <select
    value={fiatCurrency}
    onChange={(e) => setFiatCurrency(e.target.value)}
    style={{
      width: '100%',
      padding: '10px 12px',
      fontSize: '14px',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      boxSizing: 'border-box'
    }}
  >
    <option value="">Select currency...</option>
    {SUPPORTED_FIAT.map(fiat => (
      <option key={fiat.code} value={fiat.code}>
        {fiat.name}
      </option>
    ))}
  </select>
  <p style={{
    fontSize: '12px',
    color: '#6b7280',
    marginTop: '6px',
    margin: '6px 0 0 0'
  }}>
    Local currency for pricing. Automatically converted to {genericToken || 'crypto'} at market rate.
  </p>
</div>



          {error && (
            <div style={{
              background: '#fee2e2',
              color: '#991b1b',
              padding: '10px 12px',
              borderRadius: '8px',
              fontSize: '13px',
              marginBottom: '16px',
              border: '1px solid #fecaca'
            }}>
              ⚠️ {error}
            </div>
          )}

          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                flex: 1,
                padding: '12px',
                fontSize: '14px',
                fontWeight: '500',
                background: 'white',
                color: '#6b7280',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                flex: 1,
                padding: '12px',
                fontSize: '14px',
                fontWeight: '600',
                background: loading ? '#9ca3af' : 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'Creating...' : 'Create Token'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const QRModal = ({ token, qrCodeUrl, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
          color: 'white',
          padding: '20px',
          borderRadius: '16px 16px 0 0'
        }}>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
            {token.name}
          </h2>
          <p style={{ margin: '8px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
            Scan with POS to initialize
          </p>
        </div>

        <div style={{ padding: '30px' }}>
          <img src={qrCodeUrl} alt="Token QR Code" style={{ maxWidth: '100%', borderRadius: '8px' }} />
          
          <div style={{
            marginTop: '20px',
            padding: '12px',
            background: '#f9fafb',
            borderRadius: '8px',
            border: '1px solid #e5e7eb'
          }}>
            <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>
              Human Code
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: '700',
              fontFamily: 'monospace',
              color: '#1e40af',
              letterSpacing: '4px'
            }}>
              {token.humanCode}
            </div>
          </div>
        </div>

        <div style={{ padding: '0 20px 20px 20px' }}>
          <button
            onClick={onClose}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '14px',
              fontWeight: '500',
              background: 'white',
              color: '#6b7280',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenManagement;